var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('Button',{staticClass:"color-link",attrs:{"type":_vm.color,"small":_vm.small,"uppercase":_vm.uppercase,"has-icon":_vm.icon,"link":"","outlined":_vm.outlined}},[_c('AcfLink',{attrs:{"data":_vm.link}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }